export type SiteConfig = {
  locales: string[];
  defaultLocale: string;
  localePrefix: 'always' | 'as-needed' | 'never';
};

export const defaultConfig: SiteConfig = {
  locales: ['en'],
  defaultLocale: 'en',
  localePrefix: 'always',
};

export const sites: Record<string, SiteConfig> = {
  'localhost:3000': {
    ...defaultConfig,
    locales: ['en', 'kr'],
  },
  '0xd26207fa2829326927969ffb855a01715fb9505a': {
    ...defaultConfig,
    locales: ['en', 'kr'],
  },
  '0x74c48c0827a1b550121094a329f461563f32e6b4': defaultConfig,
  '0x68001551192e7fe14736a22b7a7d0bf4cc74d6e7': defaultConfig,
  '0xbe5c297f5c4ebd3ac3f0ed6aae7aede433a6fb4d': defaultConfig,
  '0xe0a28c1604374e34885c14d966ff44faf0b25f35': defaultConfig,
  '0x961402369c593d33a679241af6ce8b59933c2573': defaultConfig,
  //SECTION - PRODUCTION NODES
  '0xe477d6662870b51b590744bbd1768cbb014f6d61': {
    ...defaultConfig,
    locales: ['en', 'kr'],
  },
  '0x8f73eb92c5010b4d26a4891f1bfdcb9b682b8e78': defaultConfig,
  '0x1ec12215d0b9757c9d77124bb02c949a0377ac94': defaultConfig,
};
